<ion-row class="ion-align-items-center">
  <ion-col size="12" size-sm>
    <ion-row class="ion-align-items-center">
      <ion-col size="12" size-sm>
        <div class="phi-flex-wrap-center phi-gap-10">
          <!-- -------------------------------------- Year ---------------------------------------- -->
          <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="selectedYearForDWM" (selectionChange)="getYearSetupForDWM(selectedYearForDWM)">
              <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                {{ sharedService.transformYearToFyFormat(item.year) }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- -------------------------------------- Months ---------------------------------------- -->
          <mat-form-field class="w-100 mat-height40 mw-sm-150 mat-input-style">
            <mat-select placeholder="Select Month" [(ngModel)]="selectedMonthForDWM" (selectionChange)="changeReportsData()">
              <mat-option *ngFor="let month of filteredMonthsList" [value]="month">
                {{ month }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- -------------------------------- Department Dropdown ------------------------------- -->
          <!-- <ng-select *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="false" placeholder="Select Department" (change)="onDepartmentChange($event)" [(ngModel)]="selectedDepartment" dropdownPosition="bottom">
            <ng-option [value]="departments" *ngFor="let departments of departmentsList">{{departments}}</ng-option>
          </ng-select> -->

          <!-- -------------------------------- Department Multiselect ------------------------------- -->
          <ng-multiselect-dropdown *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin" class="w-100 department-auto-width mw-sm-200 mat-height40 mat-input-style" [data]="departmentsList" [(ngModel)]="selectedDepartments" [settings]="departmentDropdownSettings" placeholder="Select Department" (onSelect)="onDepartmentMultiChange()" (onDeSelect)="onDepartmentMultiChange()" (onSelectAll)="onDepartmentSelectAll()" (onDeSelectAll)="onDepartmentDeSelectAll()"></ng-multiselect-dropdown>

          <!-- -------------------------------- Grade Dropdown ------------------------------- -->
          <!-- <ng-select *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="false" placeholder="Select Grade" (change)="onGradeChange($event)" [(ngModel)]="selectedGrade" dropdownPosition="bottom">
            <ng-option [value]="grades" *ngFor="let grades of gradesList">{{grades}}</ng-option>
          </ng-select> -->

          <!-- -------------------------------- Grade Multiselect ------------------------------- -->
          <ng-multiselect-dropdown *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-150 mat-height40 mat-input-style" [data]="gradesList" [(ngModel)]="selectedGrades" [settings]="gradeDropdownSettings" placeholder="Select Grade" (onSelect)="onGradeMultiChange()" (onDeSelect)="onGradeMultiChange()" (onSelectAll)="onGradeSelectAll()" (onDeSelectAll)="onGradeDeSelectAll()"></ng-multiselect-dropdown>

          <!-- -------------------------------- Employee Dropdown For Super Admin & HR Admin------------------------------- -->
          <ng-select *ngIf="(loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || userIsAdminTypes?.userIsAdmin) && !isRndAdminUser" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedFilters.selectedEmpId" (change)="onAdminEmployeeChange($event)" dropdownPosition="bottom">
            <ng-option [value]="employee.id" *ngFor="let employee of employeesList">{{ employee.firstName }} {{ employee.lastName }}</ng-option>
          </ng-select>

          <!-- -------------------------------- Employee Dropdown for Manager ------------------------------- -->
          <ng-select *ngIf="(loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD') && isTeamView && !isRndAdminUser" class="w-100 mw-sm-250 mat-height40 mat-input-style" bindLabel="name" bindValue="id" [clearable]="false" placeholder="Select Employee" (change)="onEmployeeChange($event)" [(ngModel)]="selectedFilters.selectedEmpId" dropdownPosition="bottom">
            <ng-option [value]="item.id" *ngFor="let item of getIndirectEmployees">{{item.name}}</ng-option>
          </ng-select>

          <!-- -------------------------------- Employee Dropdown for R&D Admin ------------------------------- -->

          <ng-select *ngIf="(isRndAdminUser && isTeamView) || ((loggedInUserRole=='HOD' || loggedInUserRole=='Manager') && (isRndAdminUser && isTeamView))" bindLabel="name" bindValue="id" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="false" placeholder="Select Employee" [(ngModel)]="selectedFilters.selectedEmpId" (change)="onEmployeeChange($event)" dropdownPosition="bottom">
            <ng-option *ngFor="let item of rndAdminEmployees" [value]="item.id">
              {{ item.name }}
            </ng-option>
          </ng-select>
          <span class="total-hours ion-hide-sm-down" *ngIf="shouldShowRndReport">
            Total Hours Worked =
            <strong class="ml-5">
              {{ getComplianceData?.totalHoursWorked || '00:00' }}
            </strong>
          </span>
        </div>
      </ion-col>
      <ion-col size="12" size-sm="auto" class="ion-text-end ion-align-self-center" *ngIf="loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD'">
        <mat-slide-toggle [(ngModel)]="isTeamView" (change)="onTeamToggleChange($event.checked)" color="primary">
          {{ isTeamView ? 'Team' : 'Self' }}
        </mat-slide-toggle>
      </ion-col>
    </ion-row>
  </ion-col>
  <!-- <ion-col size="auto"> -->
  <ion-col size="12" size-sm="auto" class="ion-text-md-end">
    <div class="phi-flex-wrap phi-justify-content-end phi-gap-10">
      <!-- Refresh Icon -->
      <span *ngIf="shouldShowRndReport" class="fs-20 material-icons btn-reset" style="cursor:pointer;" [class.clicked]="isClicked" (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">refresh</span>

      <!-- Download Icon -->
      <img *ngIf="shouldShowRndReport && mobileResponsiveService.getIfWebLogin" src="assets/svg/excel.svg" class="file-icon mr-5" (click)="onBtExport()" />
    </div>
  </ion-col>
  <!-- </ion-col> -->
</ion-row>

<ion-row class="ion-hide-sm-up mb-15">
  <ion-col size>
    <span class="total-hours" *ngIf="shouldShowRndReport">
      Total Hours Worked =
      <strong class="ml-5">
        {{ getComplianceData?.totalHoursWorked || '00:00' }}
      </strong>
    </span>
  </ion-col>
</ion-row>
<div class="card" *ngIf="selectedMonthForDWM && shouldShowRndReport ">
  <mat-sidenav-container style="height: 100%;">
    <mat-sidenav-content>
      <ag-grid-angular style="width: 100%; height: 300px;" class="ag-theme-quartz responsive-page-bar" [rowData]="reportsData" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" [pagination]="pagination" [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight" [localeText]="{ noRowsToShow: 'No Data Found' }"></ag-grid-angular>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- ----------------------------- Reports data for the Non R&D employee ------------------------------ -->
<div class="table-card-box mb-15 mt-10">
  <!-- <div class="phi-flex-wrap justify-content-flex-end phi-gap-6">
    <img src="assets/svg/pdf.svg" class="file-icon" (click)="downloadPDFAndExcel('pdf')" />
    <img src="assets/svg/excel.svg" class="file-icon mr-5" (click)="downloadPDFAndExcel('excel')" />
  </div> -->
  <ion-row *ngIf="(isAdminUser && selectedFilters.selectedEmpId ) || (isTeamView && (loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD') && selectedFilters.selectedEmpId) || (isSelfView && !isAdminUser);">
    <ion-col size>
      <div class="phi-flex-wrap-center phi-gap-12 mb-5">
        <span class="achievment">
          Achievement =
          <strong class="ml-5 ">{{ getComplianceData?.complianceScore ?? 0 }}%</strong>
        </span>
      </div>
    </ion-col>
    <ion-col size="auto">
      <div class="phi-flex-wrap-center phi-gap-12">
        <div class="download-btns phi-flex-wrap-center phi-gap-12">
          <img src="assets/svg/pdf.svg" class="file-icon" (click)="downloadPDFAndExcel('pdf')" />
          <img src="assets/svg/excel.svg" class="file-icon mr-5" (click)="downloadPDFAndExcel('excel')" />
        </div>
      </div>
    </ion-col>
  </ion-row>
  <!-- -------------------------- Task List Table ---------------------------- -->
  <ion-row *ngIf="(isAdminUser && selectedFilters.selectedEmpId ) || (isTeamView && (loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD') && selectedFilters.selectedEmpId) || (isSelfView && !isAdminUser)">
    <ion-col>
      <div class="table-container">
        <table class="hover mb-15 ">
          <thead>
            <tr>
              <th>Category</th>
              <th>Actionable</th>
              <th>Frequency</th>
              <th *ngFor="let day of daysInMonth" class="text-center fs-12">{{ day }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let reportData of groupedReportData; let i = index">
              <tr class="fs-14 fs_12ForMobile font_regular">
                <!-- Category -->
                <td>{{ reportData.categoryName }}</td>

                <!-- Actionable -->
                <td class="fs-14 fs_12ForMobile font_regular">
                  <textarea rows="1" cols="4" class="dwmEdittextarea" readonly>{{ reportData.actionable || 'N/A' }}</textarea>
                </td>

                <!-- Frequency -->
                <td class="fs-14 fs_12ForMobile font_regular">
                  {{ formatedataVariable(reportData.dwmFrequency) }}
                </td>

                <!-- Day columns -->
                <td *ngFor="let day of daysInMonth" class="text-center">
                  <div class="dwm-status-icons p-5">
                    <!-- Off-day (Weekly Off / Holiday) takes priority over any auto-generated task
                         row for that date — unless the day was explicitly marked Skipped, which is
                         a deliberate action and should still show as before. -->
                    <ng-container *ngIf="!hasSkippedEvent(reportData.events[day]) && (isWeeklyOff(day) || isHoliday(day)); else taskOrNaBlock">
                      <span *ngIf="isWeeklyOff(day)" class="wo-text">WO</span>
                      <span *ngIf="!isWeeklyOff(day) && isHoliday(day)" class="h-text">H</span>
                    </ng-container>

                    <ng-template #taskOrNaBlock>
                      <!-- When tasks exist -->
                      <ng-container *ngIf="reportData.events[day]?.length; else naBlock">
                        <div *ngFor="let ev of reportData.events[day]" class="hourly-status-block" style="margin-bottom: 4px;">
                          <!-- SKIP ICON (ONLY ADDITION) -->
                          <span *ngIf="ev.isSkipped" class="skip-day-square" matTooltip="Skipped Day"></span>

                          <!-- HOURLY TIME (unchanged, just skip-safe) -->
                          <div *ngIf="!ev.isSkipped && reportData.dwmFrequency === 'HOURLY'" class="hour-time">{{ ev.time }}</div>

                          <!-- Status Icon : Not Started -->
                          <mat-icon *ngIf="!ev.isSkipped && ev.status == 'Not_Started'" class="dwm-status-icon active not-started" [matTooltip]="dwmGenericServiceService.getStatusLabel(ev.status)">cancel</mat-icon>

                          <!-- Status Icon : In Progress -->
                          <mat-icon *ngIf="!ev.isSkipped && ev.status == 'In_Progress'" class="dwm-status-icon active in-progress" [matTooltip]="dwmGenericServiceService.getStatusLabel(ev.status)">radio_button_checked</mat-icon>

                          <!-- Status Icon : Completed -->
                          <mat-icon *ngIf="!ev.isSkipped && ev.status == 'Completed'" class="dwm-status-icon active complete" [matTooltip]="dwmGenericServiceService.getStatusLabel(ev.status)">check_circle</mat-icon>

                          <!-- Status Icon : Done with delay -->
                          <mat-icon *ngIf="!ev.isSkipped && ev.status == 'Done_with_delay'" class="dwm-status-icon active complete-delay" [matTooltip]="dwmGenericServiceService.getStatusLabel(ev.status)">check_circle</mat-icon>
                        </div>
                      </ng-container>

                      <!-- N/A -->
                      <ng-template #naBlock>
                        <span class="na-text">N/A</span>
                      </ng-template>
                    </ng-template>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>



<!--  ADD THIS HERE -->
<ng-template #noEmployeeSelected>
  <div class="text-center p-20 fs-14">
    Please select an employee to view records.
  </div>
</ng-template>
      <!-- -------------------------- Pagination ---------------------------- -->

      <div class="phi-flex-wrap-center-space-between-gap6 mt-10">
        <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{ showingCount }} to {{ showingOfCount }} of {{ totalTaskCount }} entries</ion-label>

        <div class="phi-flex-wrap-center phi-gap-12">
          <div class="phi-flex-wrap-center phi-gap-8">
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" (selectionChange)="onSelectSizeCount()" [(ngModel)]="selectedSizeOfTask">
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
          </div>

          <ul class="dt_pagination">
            <li class="active fs-16 fs_14ForMobile font_regular">
              {{ currentPageNumber }}
            </li>
            <span class="fs-14 fs_12ForMobile font_regular p-10">of {{ totalTaskPages }}</span>
            <li class="fs-24 fs_18ForMobile cp" (click)="previousPageTask()" [ngClass]="{ disableBtn: currentPageNumber === 1 }">&lt;</li>
            <li class="fs-24 fs_18ForMobile cp" (click)="nextPageTask()" [ngClass]="{ disableBtn: currentPageNumber >= totalTaskPages }">&gt;</li>
          </ul>
        </div>
      </div>
    </ion-col>
  </ion-row>
</div>
